import { Button, ButtonGroup, Paper, Stack, Typography } from '@mui/material';
import { useDownloadMzkordMutation, useResetJobDataMutation, useUploadJobDataMutation } from '../../features/po/poSlice';
import { useState } from 'react';
import Upload from '../../components/Upload';
import Loading from "../../components/Loading";
import { DraftFromJobDataUploader } from './UploadJDBox';
import FastForwardRoundedIcon from '@mui/icons-material/FastForwardRounded';
import { useUpdateOrderMutation } from '../../features/model/orderSlice';

const JobDataUploader = ({order, afterUpload=null}) => {
  const [ uploadJobDataMutation ] = useUploadJobDataMutation();

  return <Upload onUpload={async (data) => {
    await uploadJobDataMutation({order_id: order.id, data: data.data})
    if(afterUpload) {
      afterUpload();
    }
  }} />
};


const PurchaseOrderAdminActions = ({order}) => {
  const [ showUpload, setShowUpload ] = useState(false);
  const [ confirmReset, setConfirmReset ] = useState(false);
  const [ refreshJobData, setRefreshJobData ] = useState(false);
  const [ updateOrder, { isSuccess: orderUpdated } ] = useUpdateOrderMutation();
  const [ downloadMzkordMutation ] = useDownloadMzkordMutation();
  const [ resetJobDataMutation, {isLoading, isSuccess, isError} ] = useResetJobDataMutation();

  const downloadMzkord = () => {
    downloadMzkordMutation(order.id)
    .then((data) => {
      const url = window.URL.createObjectURL(new Blob([data.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = `PO_${order.order_id}.mzkord`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    })
  };
  const uploadJobData = () => {
    setShowUpload(true);
  };
  const resetProduction = () => {
    setConfirmReset(false);
    resetJobDataMutation({order_id: order.id});
  };
  if (orderUpdated) {
    window.location.reload();
  }

  return <Paper sx={{ padding: 2, maxWidth: 450 }}>
    <Typography variant="h2">Actions</Typography>
    <Stack direction="column" sx={{gap: 1}}>
      <Button variant="contained" onClick={downloadMzkord}>Download MZKORD</Button>
      <Button variant="outlined" onClick={uploadJobData}>Create doors from Jobdata.db
      {showUpload && <JobDataUploader order={order} afterUpload={() => {
        setShowUpload(false);
      }}/>}
      </Button>
      <Button variant="outlined" onClick={() => {setRefreshJobData(true)}}>Replace draft with new Jobdata.db
      {refreshJobData && <DraftFromJobDataUploader order={order} afterUpload={() => {
        window.location.reload();
      }} />}
      </Button>
      {order.status !== 'draft' && order.status !== 'shipped' &&
        <Button variant="outlined" color="warning" onClick={() => {
          updateOrder({order_id: order.id, data: {status: 'rush'}});
        }}>
        <FastForwardRoundedIcon /> RUSH
        </Button>}
      <Stack direction="row" spacing={1}>
        <Button disabled={isLoading} variant="outlined" sx={{flexGrow: true, flex: 1, display: "flex"}} onClick={() => {setConfirmReset(!confirmReset);}}>Reset all production data</Button>
        { confirmReset && <Button disabled={isLoading} sx={{flexGrow: true, flex: 1, display: "flex"}} color="error" variant="contained" onClick={resetProduction}>Just do it, I know what I'm doing</Button>}
      </Stack>
      { isLoading && <Loading /> }
      </Stack>
  </Paper>
}

export { PurchaseOrderAdminActions };